var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNaverLogo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_295_329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.159 8.14L4.74395 0H0.253662V15.2H4.96322V7.06L10.3783 15.2H14.8686V0H10.159V8.14Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_295_329"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.6149,
    height: 15.2,
    fill: "white",
    transform: "translate(0.253662)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNaverLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/NaverLogo.2d1fcee6.svg";
export { ForwardRef as ReactComponent };